import React from "react";
import { FaHome } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
export default function BreadCrumbTable({
  base = true,
  title,
  subTitle,
  ...rest
}) {
  const navigate = useNavigate();

  return (
    <h5 className="fs-9 mb-0 text-nowrap py-2 py-xl-0">
      {base === true && (
        <>
          <FaHome
            size={20}
            style={{ marginBottom: 5, cursor: "pointer" }}
            onClick={() => navigate("/")}
          />{" "}
          {title && " | "}

        </>
      )}{" "}
      {title}
      {subTitle && " | "}
      {subTitle}
      {Object.entries(rest).map(
        ([key, value]) => value && <span key={key}> | {value}</span>
      )}
    </h5>
  );
}
